module.exports = __webpack_public_path__ + "img/3 - 3 - 3 - 1.3bb36417.jpg";